<template>
    <div :key="journal.ID" class="ml-0">
        <p class="text-subtitle-1 my-3 font-weight-medium font-weight-black">
            Hybrid publishing model
            <v-btn v-if="bo" x-small class="mt-1 ml-2 white--text" color="green darken-4"
                :to="{name:'journal.edit.bo',params:{id:this.$route.params.journal_id,model:'Hybrid'}}" >
                edit
            </v-btn>
        </p>
        <div class="ql-ed">
            <span v-html="hybrid"></span>
        </div>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
import router from '../../../router';

export default {
    props:{
        bo: {
            type:Boolean,
            default:false
        },
    },
    data() {
        return{
            hybrid:null,
        }
    },
    created() {
        this.gethybrid();
    },
    computed:{
        ...mapGetters('library',{
            journal:'journal',
        })
    },
    methods: {
        async gethybrid(){
            try{
                const res = await axios.get('/index.php/api/library/journals/hybrid/'+this.$route.params.journal_id );
                if(res){
                    this.hybrid = res.data;
                }
            } catch (error) {
                throw error;
            }
        },
    },
}
</script>
